import { RecipeTextLineItem } from '~/types/queriesResponse/getRecipesWishlistsResponse';

export default class RecipeWishlistItem {
  name: string;
  id: string;
  contentfulId: string;
  image: string;

  constructor(name: string, id: string, contentfulId: string, image: string) {
    this.name = name;
    this.id = id;
    this.contentfulId = contentfulId;
    this.image = image;
  }

  static fromTextLineItem(item: RecipeTextLineItem): RecipeWishlistItem {
    return new RecipeWishlistItem(
      item.name,
      item.id,
      item.custom?.customFieldsRaw?.find((field) => field.name === 'contentful-id')?.value,
      item.custom?.customFieldsRaw?.find((field) => field.name === 'image')?.value,
    );
  }
}
